<template>
    <Layout1 :title="`Log in to <cloudName> ${partnerID ? 'by ' + partnerID : ''}`">
      <template slot="form">
        <div v-if="$route.path === '/account-locked'">
          <span class="fs16">You made {{ attempts }} failed login attempts due to which, your account has been locked.</span>
          <div class="mt-1">
            <router-link class="link text-primary-apiculus" to="recover-account">Recover my Account</router-link>
          </div>
        </div>
        <form v-if="$route.path === '/password-expired'" @submit.prevent="setPassword()">
          <span class="fs16"><span class="text-transform-none">{{ cloudName }}</span> Requires all users to reset their passwords every
            {{ expiry }} days. Please set a new password to log back in.</span>
          <div class="form-floating mb15 mt-2">
            <input ref="password" type="password" id="password" name="Password" v-model="form2.password"
              placeholder="Type a password" class="form-control fn14"
              v-validate="{ required: true, regex: $store.state.passwordRegex }" />
            <label for="password">Type a password</label>
            <small class="col_error" v-show="errors.has('Password')">{{ errors.first('Password') }}</small>
          </div>
          <div class="form-floating mb15">
            <input type="password" id=" password" name=" password" v-model="form2.confirmPassword"
              placeholder="Confirm Password" class="form-control fn14"
              v-validate="{ required: true, confirmed: form2.password, regex: $store.state.passwordRegex }" />
            <label for=" password">Confirm Password</label>
            <small class="col_error" v-show="errors.has(' password')">{{ errors.first(' password') }}</small>
          </div>

          <v-card-actions class="p-0">
            <button class="btn btn-apiculus-primary mr-2" type="submit"
              :disabled="!(fields.Password && fields.Password.valid && fields[' password'] && fields[' password'].valid)">SUBMIT</button>
            <a class="col_primary" href="/">CANCEL</a>
          </v-card-actions>
        </form>
        <!-- <form @submit.prevent="loginNew()">
            <div class="form-floating mb15">

            </div>
          </form> -->
        <form v-if="!$route.query.ott && $route.path !== '/password-expired' && $route.path !== '/account-locked'"
          @submit.prevent="loginNew()">
          <div class="form-floating mb15">
            <input type="email" id="email" name="email" v-model="form.email" placeholder="Email" class="form-control fn14"
              v-validate="'required|email'" />
            <label for="email">Email</label>
            <small class="col_error" v-show="errors.has('email')">{{ errors.first('email') }}</small>
          </div>

          <div class="mb15">
            <div class="input-group">
              <div class="form-floating form-floating-group flex-grow-1">
                <input :type="showPassword ? 'text' : 'password'" id="password" name="password" v-model="form.password"
                  placeholder="Password" v-validate="{ required: true }" class="form-control fn14 br-none" />
                <label for="password">Password</label>
              </div>
              <span class="input-group-text bg_white cursor_p" @click="showPassword = !showPassword">
                <v-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</v-icon>
              </span>
            </div>
            <small class="col_error" v-show="errors.has('password')">{{ errors.first('password') }}</small>
          </div>
          <div v-if='showOTP' class="mb-2">
            <div class="form-floating">
              <input type="number" id='OTP' v-model="OTP" :disabled="!checkConfigdata" data-vv-name="OTP"
                v-validate="'required'" class="form-control fn14" name="OTP" placeholder="OTP" />
              <label for="OTP">OTP</label>
              <small class="col_error" v-show="errors.has('OTP')">{{ errors.first('OTP') }}</small>
            </div>
            <p v-if='counterMessage' class='pb-0 col-md-12 fn14'>You can request another OTP in <strong>{{ counter }}</strong>
              sec</p>
            <p v-if='showResendBtn' class="text-primary-apiculus link fn14 mt-2" @click='resendOTP()'>Resend OTP</p>
          </div>
          <router-link class="col_primary fn14" to="/forgot-password">I don't remember my password</router-link>
          <div class="mb20 mt20">
            <input type="submit" class="btn btn-apiculus-primary p10" value="LOGIN SECURELY TO YOUR ACCOUNT" />
          </div>
          <span v-if='!adminOnly' class="col_grey75 fn14">Don't have an account? <router-link class="col_primary"
              to="/signup">Sign Up</router-link></span>
        </form>
      </template>
    </Layout1>
  </template>

  <script>
  import Layout1 from './Layout1.vue'
  import HTTP from '@/services/http-request-handler'
  import VueCookie from 'vue-cookie'
  import { mapGetters } from 'vuex'
  import { eventBus } from '@/main'
  import VueCookies from 'vue-cookies'
  import helpers from '../../services/toast-service'

  export default {
    name: 'Login2',
    mixins: [helpers],
    data() {
      return {
        eventBus: eventBus,
        checkTwoFACall: true,
        showResendBtn: false,
        counterMessage: false,
        counter: this.$store.state.ApiculusEnv.OTPTimer || 20,
        showOTP: false,
        loginMessage: '',
        OTP: '',
        form: {
          email: null
        },
        cloudName: '',
        color: '',
        // bannerVisible: false,
        full_screen: '',
        message: '',
        navLogo: '',
        bannerAsset: '',
        showPassword: false,
        bannerShow: false,
        bannerElement: false,
        checking: '',
        banner: this.$store.state.ApiculusEnv.labels.brand_image_path,
        adminOnly: Boolean,
        attempts: this.$store.state.ApiculusEnv.passwords.passwordLockout,
        expiry: this.$store.state.ApiculusEnv.passwords.passwordExpiry,
        passExpiredEmail: '',
        passExpiredToken: '',
        form2: {
          password: null,
          confirmPassword: null
        },
      }
    },
    computed: {
      ...mapGetters({
        listAllAssets: 'getAllAssets'
      }),
      partnerID () {
      return this.$route.params && this.$route.params.partnerID ? this.$route.params.partnerID : ''
    },
      checkConfigdata() {
        return (Object.keys(this.$store.state.ApiculusEnv).length > 0)
      },
      twoFactorAuth() {
        return this.checkConfigdata && Boolean(this.$store.state.ApiculusEnv.features.twoFactorAuth)
      },
      title() {
        if (this.$route.path == '/') {
          return 'Log in to <cloudName>'
        } else if (this.$route.path === '/account-locked') {
          return 'Your account has been locked'
        } else if (this.$route.path === '/password-expired') {
          return `Your password is more than ${this.expiry} days old`
        }
      },
    },
    components: {
      Layout1
    },
    methods: {
      otpTimer() {
        let interval = setInterval(() => {
          this.counter--;
          if (this.counter <= 0) {
            clearInterval(interval);
            this.counterMessage = false,
              this.showResendBtn = true
            return;
          }
        }, 1000);
      },
      resendOTP() {
        this.$store.dispatch('ACTION_RESEND_OTP', { email: this.form.email }).then((res) => {
          if (res.success) {
            this.counterMessage = true
            this.counter = this.$store.state.ApiculusEnv.OTPTimer
            this.showResendBtn = false
            this.otpTimer()
          }
        })
      },
      signUp() {
        this.$router.push({ name: 'signup' })
      },
      loginNew() {
        if (!this.otpLogin) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.$store.dispatch('ACTION_GET_STATE', {
                email: this.form.email,
                password: this.form.password,
              }).then((res) => {
                if (res.error) {
                  if (res.error.message === 'Account blocked due to incorrect Login attempts') {
                    this.$router.push({ path: 'account-locked' })
                  } else {
                    this.toastAlert(res.error.message || 'Something went wrong.', 'error')
                  }
                  return
                } else if (res.success && res.message === 'password expired') {
                  this.$router.push({ path: 'password-expired' })
                  this.passExpiredEmail = res.email
                  this.passExpiredToken = res.token
                  return
                }

                if ((res.result.account_type == 0 || res.result.account_type == 1)) {
                  if (!this.$store.state.ApiculusEnv.features.twoFactorAuthSubs) {
                    this.logIN()
                  }
                  else {
                    this.checkTwoFACall = true
                    this.isOtpLogin = true
                    this.loginOTP()
                  }
                }
                if ((res.result.account_type == 11 || res.result.account_type == 12 || res.result.account_type == 2)) {
                  if (!this.$store.state.ApiculusEnv.features.twoFactorAuthAdmin) {
                    this.logIN()
                  }
                  else {
                    this.checkTwoFACall = true
                    this.isOtpLogin = true
                    this.loginOTP()
                  }
                }
              })
            }
          })
        }
        else {
          this.loginOTP()
        }
      },
      logIN() {
        if (this.$route.query.ott) {
          this.form.email = this.$store.state.ApiculusEnv.ottLogin.username
          this.form.password = this.$store.state.ApiculusEnv.ottLogin.password
        }
        this.$store.dispatch('ACTION_AUTH_LOGIN', {
          email: this.form.email,
          password: this.form.password,
          ott: this.$route.query.ott,
        }).then((res) => {
          console.log('LOGIN COMPONENT RES :::: ', res)
          if (res.success) {
            if (res.result && res.result.message && res.result.message === 'password expired') {
              this.$router.push({ path: 'password-expired' })
              this.passExpiredEmail = res.result.email
              this.passExpiredToken = res.result.token
              return
            }
            VueCookie.delete('childGroupName')
            VueCookie.delete('parentGroupName')
            VueCookie.delete('userName')
            VueCookie.delete('userRole')
            VueCookie.delete('userID')
            HTTP.defaults.headers['x-access-token'] = res.result.token

            this.$store.state.userDetails = 'getData'

            // this.$store.dispatch('ACTION_USERDETAIL_MEE').then((res)=>{
            //   console.log('res=>>>>>>', res)
            //   // this.$store.state.parentGroupName= res.parentGroup
            //   VueCookie.set('parentGroupName', res.parentGroup)
            //   if (res && res.hasOwnProperty('childGroup')) {
            //     VueCookie.set('childGroupName', res.childGroup)
            //   }
            //   // this.$store.state.userRole= res.role
            //   VueCookie.set('userRole', res.role)
            //   VueCookie.set('userID', res.id)
            //   // this.$store.state.userName= res.name
            //   VueCookie.set('userName', res.name)
            // })
            HTTP.get('op_getAccountState').then(response => {
              VueCookie.set('access-token', res.result.token)
              VueCookies.set('access-token-key', res.result.token, null, null, null, true, 'None')
              VueCookie.set('currency', res.result.currency)
              VueCookie.set('last_logged_in', res.result.last_logged_in)
              VueCookie.set('paymentCurrency', res.result.paymentCurrency)
              VueCookie.set('account_type', res.result.account_type)
              VueCookie.set('account_id', response.data.result.ID)
              if (response.data.result.account_state > 0) {
                // response.data.result.account_state = 17.02
                let username = `${response.data.result.first_name} ${response.data.result.last_name}`
                VueCookie.set('username', username)
                VueCookie.set('email', response.data.result.email)
                if (response.data.result.hasOwnProperty('parent_account_id')) {
                  let parentId = response.data.result.parent_account_id
                  VueCookie.set('parentId', parentId)
                }
                if (response.data.result.account_state.toString().split('.')[1] === '02') {
                  VueCookie.set('account_state', 'SUSPENDED')
                } else {
                  VueCookie.set('account_state', response.data.result.account_state)
                }
              }

              if (res.result.account_type == 2) {
                VueCookie.set('resellerId', res.result.resellerId)
                VueCookie.set('resellerCode', res.result.resellerCode)
              }

              if (res.result.account_type == 12 || res.result.account_type == 11 || res.result.account_type == 2) {
                window.location.replace('/admin/')
              } else {
                window.location.replace('/site/')
              }
            })
          } else {
            if (res.error.message === 'Account blocked due to incorrect Login attempts') {
              this.$router.push({ path: 'account-locked' })
            } else {
              this.toastAlert(res.error.message || 'Something went wrong, Please try again later.', 'error')
            }
          }
          // if (res.result.account_type === 12) {
          //   window.location.replace('http://localhost:8081/admin/')
          //   // window.location.replace('http://cloud.apiculus.iqtest:8443/static/#/')
          // } else {
          //   window.location.replace('http://localhost:8081/site/')
          // }
          // this.showNotification('success', 'success', 'Login Successfull')
        }).catch(e => {
          console.log('LOGIN COMPONENT ERR :::: ', e)
          this.toastAlert(e.response.error.message || 'Something went wrong.', 'error')
        })

      },
      loginOTP() {
        // this.$validator.validateAll().then((result) => {
        //   if (result) {
        //     //  else {
        if (this.checkTwoFACall) {
          this.$store.dispatch('ACTION_TWO_FACTOR_AUTH', { email: this.form.email, password: this.form.password }).then(res => {
            console.log('2FsssA login', res)
            if (res.success) {
              this.counterMessage = true
              this.showOTP = true
              this.loginMessage = 'LOGIN'
              this.checkTwoFACall = false
              this.otpLogin = true
              this.otpTimer()
            } else {
              this.toastAlert(res.error.message || 'Something went wrong, Please try again later.', 'error')
            }
          }).catch(e => {
            console.log('LOGIN COMPONENT ERR :::: ', e)
            this.toastAlert(e.response.error.message || 'Something went wrong.', 'error')
          })
        } else {
          this.$store.dispatch('ACTION_AUTH_LOGIN', {
            email: this.form.email,
            password: this.form.password,
            otp: Number(this.OTP),
            istwoFactorEnabled: true
          }).then((res) => {
            console.log('LOGIN COMPONENT RES :::: ', res)
            if (res.success) {
              if (res.result && res.result.message && res.result.message === 'password expired') {
                this.$router.push({ path: 'password-expired' })
                this.passExpiredEmail = res.result.email
                this.passExpiredToken = res.result.token
                return
              }
              VueCookie.delete('childGroupName')
              VueCookie.delete('parentGroupName')
              VueCookie.delete('userName')
              VueCookie.delete('userRole')
              VueCookie.delete('userID')
              HTTP.defaults.headers['x-access-token'] = res.result.token
              this.$store.state.userDetails = 'getData'

              // this.$store.dispatch('ACTION_USERDETAIL_MEE').then((res)=>{
              //   console.log('res=>>>>>>', res)
              //   // this.$store.state.parentGroupName= res.parentGroup
              //   VueCookie.set('parentGroupName', res.parentGroup)
              //   if (res && res.hasOwnProperty('childGroup')) {
              //     VueCookie.set('childGroupName', res.childGroup)
              //   }
              //   // this.$store.state.userRole= res.role
              //   VueCookie.set('userRole', res.role)
              //   VueCookie.set('userID', res.id)
              //   // this.$store.state.userName= res.name
              //   VueCookie.set('userName', res.name)
              // })

              HTTP.get('op_getAccountState').then(response => {
                VueCookie.set('access-token', res.result.token)
                VueCookies.set('access-token-key', res.result.token, null, null, null, true, 'None')
                VueCookie.set('currency', res.result.currency)
                VueCookie.set('paymentCurrency', res.result.paymentCurrency)
                VueCookie.set('last_logged_in', res.result.last_logged_in)
                VueCookie.set('account_type', res.result.account_type)
                VueCookie.set('account_id', response.data.result.ID)
                if (response.data.result.account_state > 0) {
                  // response.data.result.account_state = 17.02
                  let username = `${response.data.result.first_name} ${response.data.result.last_name}`
                  VueCookie.set('username', username)
                  VueCookie.set('email', response.data.result.email)
                  if (response.data.result.hasOwnProperty('parent_account_id')) {
                    let parentId = response.data.result.parent_account_id
                    VueCookie.set('parentId', parentId)
                  }
                  if (response.data.result.account_state.toString().split('.')[1] === '02') {
                    VueCookie.set('account_state', 'SUSPENDED')
                  } else {
                    VueCookie.set('account_state', response.data.result.account_state)
                  }
                }
                if (res.result.account_type == 2) {
                VueCookie.set('resellerId', res.result.resellerId)
                VueCookie.set('resellerCode', res.result.resellerCode)
              }
                if (res.result.account_type == 12 || res.result.account_type == 11 || res.result.account_type == 2) {
                  window.location.replace('/admin/')
                } else {
                  window.location.replace('/site/')
                }
              })
            } else {
              if (res.error.message === 'Account blocked due to incorrect Login attempts') {
                this.$router.push({ path: 'account-locked' })
              } else {
                this.toastAlert(res.error.message || 'Something went wrong, Please try again later.', 'error')
              }
            }
            // if (res.result.account_type === 12) {
            //   window.location.replace('http://localhost:8081/admin/')
            //   // window.location.replace('http://cloud.apiculus.iqtest:8443/static/#/')
            // } else {
            //   window.location.replace('http://localhost:8081/site/')
            // }
            // this.showNotification('success', 'success', 'Login Successfull')
          }).catch(e => {
            console.log('LOGIN COMPONENT ERR :::: ', e)
            this.toastAlert(e.response.error.message || 'Something went wrong.', 'error')
          })
          // }
          // this.showNotification('error', 'error', 'Please Fill All Mandatory Details')
          //     }
          //   }
          // })
        }
      },
      setPassword() {
        this.$store.dispatch('ACTION_SET_PASSWORD_AFTER_EXPIRY', {
          email: this.passExpiredEmail, token: this.passExpiredToken,
          password: this.form2.password, confirmPassword: this.form2.confirmPassword
        }).then(res => {
          if (!res.success) {
            this.toastAlert(res.error.message || 'Something went wrong, Please try again later.', 'error')
          } else {
            this.toastAlert("New password set successfully. You can login now with your new password", 'success')
            setTimeout(() => {
              // this.$router.push('/')
              window.location.href = '/'
            }, 3000)
          }
        })
      },
      ChangeBackgroungImageOfTab(imagePrefix) {
        let urlString = ''
        setTimeout(() => {
          urlString = document.getElementById('check')
          urlString.classList.add('bannerElement')
          urlString.style.backgroundImage = 'url(' + imagePrefix + ')'
        }, 0)
      }
    },
    created() {
      this.adminOnly = this.$store.state.ApiculusEnv.adminOnly
      if (this.twoFactorAuth) {
        this.loginMessage = 'CONTINUE'
      } else {
        this.loginMessage = 'LOGIN'
      }
      let faviconElement = document.getElementById('favicon')
      let titleElement = document.getElementById('cloudTitle')
      this.$store.dispatch('ACTION_LIST_ASSET', 'banner.png').then((res) => {
        this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'banner.png' }).then(res => {
          let downloadFiles
          if (res && typeof res === 'string') {
            downloadFiles = 'data:image/png;base64,' + res
            this.bannerAsset = downloadFiles
            this.bannerShow = true
          } else {
            this.bannerAsset = ''
            this.bannerShow = false
          }
          if (this.listAllAssets && this.listAllAssets.length > 0) {
            this.full_screen = this.listAllAssets[0].metadata.show_fullscreen
            if (this.full_screen === true) {
              this.ChangeBackgroungImageOfTab(this.bannerAsset)
            }
          }
        })
      })
      this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'logo-main.png' }).then(res => {
        if (res) {
          let downloadFile = 'data:image/png;base64,' + res
          this.navLogo = downloadFile
        } else {
          this.navLogo = ''
        }
      })
      this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'favicon.png' }).then(res => {
        let downloadFiles
        if (res) {
          downloadFiles = 'data:image/png;base64,' + res
          faviconElement.href = downloadFiles
        } else {
          faviconElement.href = ''
        }
      })
      this.$store.dispatch('ACTION_GET_PROFILE_DETAILS').then(res => {
        if (res) {
          titleElement.innerHTML = res.name
          this.cloudName = res.name
        }
      })
      // document.getElementById(bannerElement).style.background-image = 'url('+ bannerAsset +')';
      if (this.$route.query.ott) {
        this.logIN();
        this.twoFactorAuth = false;
      }
    }
  }
  </script>

  <style scoped></style>
